import cx from 'classnames';
import { Carousel } from 'components/carousel/Carousel';
import { isEqualVal } from 'helpers/string.helper';
import { resourceUrl } from 'helpers/url.helper';
import { map, range, slice } from 'lodash';
import { DList } from 'models/common.model';
import React from 'react';
import { useAppSelector } from 'store/store-hooks';

type EditPhotoGridSelectItemProps = {
  selectedId?: number;
  itemPerPage: number;
  listData: DList<any> | null;
  onSelectItem?: (id: number, imageUrl: string) => void;
};

const EditPhotoGridSelectItem: React.FC<EditPhotoGridSelectItemProps> = ({
  selectedId,
  itemPerPage,
  listData,
  onSelectItem,
}) => {
  const { isEventBooth } = useAppSelector((s) => s.booth);

  return (
    <div className="edit-page__edit-carousel--wrapper">
      <Carousel
        className="edit-page__edit-carousel"
        slides={range(
          1,
          Math.ceil((listData?.totalRecord || 0) / itemPerPage) + 1,
        )}
        RenderSlide={(_, ind) => (
          <div
            className={cx('edit-grid-group', {
              'event-select-theme-grid': isEventBooth,
            })}
          >
            {map(
              slice(listData?.data, ind * itemPerPage, (ind + 1) * itemPerPage),
              (item) => (
                <button
                  key={item?.id}
                  type="button"
                  className={cx('edit-carousel-item', {
                    active: isEqualVal(item?.id, selectedId),
                  })}
                  onClick={() => onSelectItem?.(item?.id, item?.imageUrl)}
                >
                  <img
                    src={resourceUrl(item?.imageUrl || item?.image)}
                    alt="item img"
                  />
                </button>
              ),
            )}
          </div>
        )}
      />
    </div>
  );
};
export default EditPhotoGridSelectItem;
